import ImportInstallationsContent from "./../modules/installation/pages/ImportInstallations/es";
import ImportCompressorsContent from "../modules/installation/pages/ImportCompressors/es";
import ImportSitesContent from "./../modules/company/pages/ImportSites/es";
import ImportClientsContent from "./../modules/company/pages/ImportClients/es";
import PrivacyPolicy from "../modules/common/pages/PrivacyPolicy/es";
import CGU from "../modules/common/pages/CGU/es";

export default {
  ImportInstallationsContent,
  ImportCompressorsContent,
  ImportSitesContent,
  ImportClientsContent,
  PrivacyPolicy,
  CGU,
};
